import React from "react";
import { motion } from "framer-motion";

const sizeClasses = {
  small: "w-6 h-6 border-2",
  medium: "w-10 h-10 border-4",
  large: "w-16 h-16 border-4",
  extraLarge: "w-24 h-24 border-4",
};

const Loader = ({ size = "medium", status, msg }) => {
  return (
    <div className="h-full w-full flex flex-col items-center justify-center gap-4">
      <motion.div
        className={`border-t-transparent border-l-transparent border-blue-500 rounded-full animate-spin ${
          sizeClasses[size] || sizeClasses.medium
        }`}
        initial={{ rotate: 0 }}
        animate={{ rotate: 360 }}
        transition={{ repeat: Infinity, duration: 1, ease: "linear" }}
      />
      {status === "success" && (
        <span className="text-md text-center max-w-[15rem]">{msg}</span>
      )}
    </div>
  );
};

export default Loader;
